import { render, staticRenderFns } from "./CustomerListing.vue?vue&type=template&id=20dac3d9&scoped=true"
import script from "./CustomerListing.vue?vue&type=script&lang=js"
export * from "./CustomerListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dac3d9",
  null
  
)

export default component.exports